export default __webpack_public_path__ + "static/underline-16-09b699b29234577a4ac24569a26092ff.svg";